module.exports = __webpack_public_path__ + "img/7.62476112.jpg";